// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pAihsdy4p8XVc5 {
  padding: var(--ds-space-150, 10px);
}
.pAihsdy4p8XVc5 .EEr9jbzRDydoZ7 {
  font-weight: var(--ds-font-weight-regular, 400);
}
.pAihsdy4p8XVc5 .nI_FJ54jfJXRo8 {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: var(--ds-space-300, 25px);
}
.pAihsdy4p8XVc5 .qTjocRf1ARRAZD {
  font-weight: var(--ds-font-weight-regular, 400);
  display: flex;
  align-items: center;
  min-height: 64px;
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.pAihsdy4p8XVc5 .fQ4QUcx0La43cq {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: var(--ds-font-weight-semibold, 600);
  overflow-wrap: break-word;
  font-size: 26px;
}
.pAihsdy4p8XVc5 .zqQWlO9gUKbuNs,
.pAihsdy4p8XVc5 .o6Mj76Nm3iC_av,
.pAihsdy4p8XVc5 .colhIX13oa_qT8 {
  font-weight: var(--ds-font-weight-regular, 400);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.pAihsdy4p8XVc5 .o6Mj76Nm3iC_av {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin: var(--ds-space-400, 32px) var(--ds-space-300, 25px) var(--ds-space-300, 25px) 30px;
}
.pAihsdy4p8XVc5:nth-last-child(2) {
  border-top: 3px solid var(--ds-border-discovery, #8270db);
  border-right: 4px solid var(--ds-border-discovery, #8270db);
  border-left: 3px solid var(--ds-border-discovery, #8270db);
}
.pAihsdy4p8XVc5:nth-last-child(2) .nI_FJ54jfJXRo8 {
  margin-top: var(--ds-space-050, 3px);
}
.pAihsdy4p8XVc5:nth-last-child(2)::before {
  margin-top: var(--ds-space-250, 20px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  content: attr(data-value);
  position: relative;
  top: var(--ds-space-negative-200, -15px);
  width: 85px;
  height: 24px;
  padding: var(--ds-space-075, 5px);
  border-radius: var(--ds-border-radius-050, 2px);
  background-color: var(--ds-border-discovery, #8270db);
  color: var(--ds-text-inverse, #ffffff);
  line-height: inherit;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planCell": `pAihsdy4p8XVc5`,
	"purchase": `EEr9jbzRDydoZ7`,
	"name": `nI_FJ54jfJXRo8`,
	"info": `qTjocRf1ARRAZD`,
	"price": `fQ4QUcx0La43cq`,
	"frequency": `zqQWlO9gUKbuNs`,
	"pricingVaries": `o6Mj76Nm3iC_av`,
	"currentPlan": `colhIX13oa_qT8`
};
export default ___CSS_LOADER_EXPORT___;
